/* ============
 * Add Recipe Procedure
 * ============
 *
 * This is the component for creating batch log
 */
import { mapGetters, mapMutations } from 'vuex';
import Forms from '../../utils/forms/forms';
import recipeProcedureService from '../../services/recipeProcedure';
import recipeProcedureTransformer from '../../transformers/recipeProcedure';

export default {
  data() {
    return {
      form: new Forms({
        recipeId: {
          value: this.recipeId,
          type: 'hidden',
        },
        name: {
          value: '',
          type: 'text',
        },
        step: {
          value: '',
          type: 'number',
        },
        equipmentId: {
          value: '',
          type: 'select',
          filterable: true,
        },
        ingredienceIds: {
          value: '',
          type: 'select',
          filterable: true,
        },
        notes: {
          value: '',
          type: 'textarea',
        },
      }),
    };
  },

  props: {
    recipeId: {
      required: true,
      type: String,
    },
    procedure: {
      required: false,
      type: Object,
    },
  },

  computed: {
    ...mapGetters({
      ingrediences: 'allRecipeIngrediences',
      equipments: 'allEquipments',
    }),
  },

  created() {
    this.form.setOptions('ingredienceIds', this.ingrediences.map(ingredience => ({
      id: ingredience.id,
      name: `${ingredience.materialName} - ${ingredience.amount} ${ingredience.unitMeasure}`,
    })));
    this.form.setOptions('equipmentId', this.equipments.map(equipment => ({
      id: equipment.id,
      name: equipment.name,
    })));
    this.form.setExtraAttr('ingredienceIds', {
      multiple: true,
    });
    if (this.procedure) {
      const procedure = Object.assign({}, this.procedure);
      this.form.assignData(this.procedure);
      if (procedure.ingrediences) {
        this.form.ingredienceIds = procedure.ingrediences.map(ingredience => ingredience.id.toString());
      }
    }
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * This method will be called when saving the form.
     */
    save() {
      this.form.loading = true;
      this.form.loading = true;
      const data = Object.assign(this.form.data(), {
        recipeId: this.recipeId,
      });
      if (this.procedure) { // update
        return recipeProcedureService.update(this.procedure.id, data)
          .then(() => this.closeModal())
          .catch((errors) => {
            this.form.loading = false;
            this.form.recordErrors(errors);
            const errorsKeys = Object.keys(this.form.errors.errors);
            this.$message({
              showClose: true,
              message: errors[errorsKeys[0]][0],
              type: 'error',
            });
          });
      }
      // create
      return recipeProcedureService.store(data)
        .then(() => this.closeModal())
        .catch((errors) => {
          this.form.loading = false;
          this.form.recordErrors(errors);
          const errorsKeys = Object.keys(this.form.errors.errors);
          this.$message({
            showClose: true,
            message: errors[errorsKeys[0]][0],
            type: 'error',
          });
        });
    },

    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },

  components: {
    VForm: require('./../form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/recipeProcedureModal/recipeProcedureModal.js